import React, { Component } from "react";
import { connect } from "react-redux";
import { loginUser, getUser } from "../../reducers/user";
import { Form } from "../../components/forms/Form";
import { Link } from "react-router-dom";

import "./Login.css";
import "../../App.css";

class Login extends Component {
  state = {
    // email: "ale.loca@yahoo.it",
    // password: "Demo123!",
  };
  async componentDidMount() {
    if (this.props.user.authToken) {
      window.location.href = "/mystores";
    }
  }
  componentDidUpdate(oldProps) {
    if (
      oldProps.user.authToken !== this.props.user.authToken &&
      this.props.user.authToken
    ) {
      window.location.href = "/mystores";
    }
  }
  _handleChangeInput = (target, value) => {
    this.setState({ [target]: value });
  };
  _handleSubmit = () => {
    const { email, password } = this.state;
    // console.log("called");
    // console.log(email, password);
    this.props.loginUser({ email, password });
  };

  _isDisabled = () => {
    const inputStatus = inputs.map(
      (input) => !!this.state[input.target] && this.state[input.target] !== ""
    );
    return typeof inputStatus.find((input) => !input) !== "undefined";
  };

  render() {
    // console.log(this.state);
    // console.log(this.props);
    return (
      <div className="login-container">
        <div>
          <div className="login-title-section">
            <h1>Accedi</h1>
            <p>
              Sei un nuovo utente? <Link to="/register">Registrati</Link>
            </p>
          </div>
          <div className="login-form-buttons-container">
            <Form
              submitButton={{
                text: "ACCEDI",
                disabled: this._isDisabled(),
                loading: this.props.loading,
              }}
              inputs={inputs}
              error={this.props.error}
              generalError={
                this.props.error === "error_login" &&
                "Accesso fallito: l'email o la password sono errati"
              }
              handleChangeInput={this._handleChangeInput}
              handleSubmit={this._handleSubmit}
              checkboxes={[
                {
                  target: "remeberMe",
                  label: "Ricordami",
                },
              ]}
              externalLink={{
                target: "externalLink",
                text: "Hai dimenticato la password o l'email?",
              }}
            />
            {/* <LoginButtons /> */}
          </div>
        </div>
      </div>
    );
  }
}

const inputs = [
  { target: "email", placeholder: "Email", type: "email" },
  { target: "password", placeholder: "Password", type: "password" },
];

const mapStateToProps = (state) => ({
  user: state.user.data,
  loading: state.user.loading,
  error: state.user.error,
});

export default connect(mapStateToProps, { loginUser, getUser })(Login);
